import crypto from 'crypto';

export const hashSecret = ({ input, secret, salt }) => {
  const key = crypto.pbkdf2Sync(secret, salt, 100000, 32, 'sha256');
  const hash = crypto.createHmac('sha256', key).update(input).digest();

  return hash.toString('hex');
};
